//===----------------------------------------------------------------------===//
//
//  Copyright 2024-2026 Trovares Inc. dba Rocketgraph.  All rights reserved.
//
//===----------------------------------------------------------------------===//

import { type ApiClient } from './apiClient';
import {
  type QueryAnswerResponse, type SubmitQueryResponse
} from './apiTypes';

/**
 * Query execution and result retrieval: submit a Cypher query, wait for it, and
 * fetch a page of its answer.
 */
export class QueryService {
  constructor(private readonly api: ApiClient) {}

  submitQuery = async (
    query: string, dataset_name: string
  ): Promise<SubmitQueryResponse> => {
    if (query.trim() === '')
      return { error: 'Query empty. Please enter a query.' } as
             SubmitQueryResponse;

    const data = {
      dataset_name: dataset_name,
      query: query
    };
    return this.api.makeRequest<SubmitQueryResponse>('query', 'post', data);
  };

  waitQuery = (
    jobId: string, offset: number, length: number
  ): Promise<string> => {
    return this.api.makeRequest<string>(
      `wait_query?job=${encodeURIComponent(jobId)}&offset=${offset}` +
      `&length=${length}`, 'get');
  };

  getAnswer = (
    jobId: string, offset: number, length: number
  ): Promise<QueryAnswerResponse> => {
    return this.api.makeRequest<QueryAnswerResponse>(
      `answer?job=${encodeURIComponent(jobId)}&offset=${offset}` +
      `&length=${length}`, 'get');
  };
}
